import evaluteImg from '../../assets/contestedLogistics/evaluateScenario.png';
import identifyImg from '../../assets/contestedLogistics/identifyBottlenecks.png';
import compareImg from '../../assets/contestedLogistics/compareAlternative.png';
import validateImg from '../../assets/contestedLogistics/validateFeasibility.png';
import decisionImg from '../../assets/contestedLogistics/smarterDecision.png';

function generateCardContent() {
    return ({
        "evaluate": {
            "title": "Evaluate thousands of scenarios",
            "description": "to understand edge cases, prepare for black swan events, and conduct sensitivity analyses",
            "image": evaluteImg,
            "backgroundColor": "#044D54",
            "color": "#FFFFFF"
        },
        "identify": {
            "title": "Identify bottlenecks and vulnerabilities",
            "description": "to help mitigate them before they impact mission outcomes",
            "image": identifyImg,
            "backgroundColor": "#F6F6F6",
            "color": "#000000"
        },
        "compare": {
            "title": "Compare alternative strategies",
            "description": "at a fraction of the speed of manual planning, increasing agility and responsiveness",
            "image": compareImg,
            "backgroundColor": "#044D54",
            "color": "#FFFFFF"
        },
        "validate": {
            "title": "Validate feasibility",
            "description": "of plans under real-world constraints with data-backed results, taking the guesswork out of planning",
            "image": validateImg,
            "backgroundColor": "#F6F6F6",
            "color": "#000000"
        },
        "decision": {
            "title": "Make faster, smarter decisions",
            "description": "to remain ahead of adversaries and respond to unforeseen events with speed",
            "image": decisionImg,
            "backgroundColor": "#044D54",
            "color": "#FFFFFF"
        }
    });
}

export default generateCardContent;